/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import {
  Contract,
  ContractFactory,
  ContractTransactionResponse,
  Interface,
} from "ethers";
import type {
  Signer,
  BigNumberish,
  AddressLike,
  ContractDeployTransaction,
  ContractRunner,
} from "ethers";
import type { NonPayableOverrides } from "../common";
import type {
  PositionManager,
  PositionManagerInterface,
} from "../PositionManager";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_vault",
        type: "address",
      },
      {
        internalType: "address",
        name: "_router",
        type: "address",
      },
      {
        internalType: "address",
        name: "_shortsTracker",
        type: "address",
      },
      {
        internalType: "address",
        name: "_weth",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_depositFee",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "_orderBook",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "sizeDelta",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "marginFeeBasisPoints",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "bytes32",
        name: "referralCode",
        type: "bytes32",
      },
      {
        indexed: false,
        internalType: "address",
        name: "referrer",
        type: "address",
      },
    ],
    name: "DecreasePositionReferral",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "sizeDelta",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "marginFeeBasisPoints",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "bytes32",
        name: "referralCode",
        type: "bytes32",
      },
      {
        indexed: false,
        internalType: "address",
        name: "referrer",
        type: "address",
      },
    ],
    name: "IncreasePositionReferral",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "admin",
        type: "address",
      },
    ],
    name: "SetAdmin",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "depositFee",
        type: "uint256",
      },
    ],
    name: "SetDepositFee",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "bool",
        name: "inLegacyMode",
        type: "bool",
      },
    ],
    name: "SetInLegacyMode",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "increasePositionBufferBps",
        type: "uint256",
      },
    ],
    name: "SetIncreasePositionBufferBps",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "isActive",
        type: "bool",
      },
    ],
    name: "SetLiquidator",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address[]",
        name: "tokens",
        type: "address[]",
      },
      {
        indexed: false,
        internalType: "uint256[]",
        name: "longSizes",
        type: "uint256[]",
      },
      {
        indexed: false,
        internalType: "uint256[]",
        name: "shortSizes",
        type: "uint256[]",
      },
    ],
    name: "SetMaxGlobalSizes",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "isActive",
        type: "bool",
      },
    ],
    name: "SetOrderKeeper",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "isActive",
        type: "bool",
      },
    ],
    name: "SetPartner",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "referralStorage",
        type: "address",
      },
    ],
    name: "SetReferralStorage",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "bool",
        name: "shouldValidateIncreaseOrder",
        type: "bool",
      },
    ],
    name: "SetShouldValidateIncreaseOrder",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "receiver",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "WithdrawFees",
    type: "event",
  },
  {
    inputs: [],
    name: "BASIS_POINTS_DIVISOR",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "admin",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_token",
        type: "address",
      },
      {
        internalType: "address",
        name: "_spender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "approve",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_collateralToken",
        type: "address",
      },
      {
        internalType: "address",
        name: "_indexToken",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_collateralDelta",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_sizeDelta",
        type: "uint256",
      },
      {
        internalType: "bool",
        name: "_isLong",
        type: "bool",
      },
      {
        internalType: "address",
        name: "_receiver",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_price",
        type: "uint256",
      },
    ],
    name: "decreasePosition",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "_path",
        type: "address[]",
      },
      {
        internalType: "address",
        name: "_indexToken",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_collateralDelta",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_sizeDelta",
        type: "uint256",
      },
      {
        internalType: "bool",
        name: "_isLong",
        type: "bool",
      },
      {
        internalType: "address",
        name: "_receiver",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_price",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_minOut",
        type: "uint256",
      },
    ],
    name: "decreasePositionAndSwap",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "_path",
        type: "address[]",
      },
      {
        internalType: "address",
        name: "_indexToken",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_collateralDelta",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_sizeDelta",
        type: "uint256",
      },
      {
        internalType: "bool",
        name: "_isLong",
        type: "bool",
      },
      {
        internalType: "address payable",
        name: "_receiver",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_price",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_minOut",
        type: "uint256",
      },
    ],
    name: "decreasePositionAndSwapETH",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_collateralToken",
        type: "address",
      },
      {
        internalType: "address",
        name: "_indexToken",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_collateralDelta",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_sizeDelta",
        type: "uint256",
      },
      {
        internalType: "bool",
        name: "_isLong",
        type: "bool",
      },
      {
        internalType: "address payable",
        name: "_receiver",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_price",
        type: "uint256",
      },
    ],
    name: "decreasePositionETH",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "depositFee",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_account",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_orderIndex",
        type: "uint256",
      },
      {
        internalType: "address payable",
        name: "_feeReceiver",
        type: "address",
      },
    ],
    name: "executeDecreaseOrder",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_account",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_orderIndex",
        type: "uint256",
      },
      {
        internalType: "address payable",
        name: "_feeReceiver",
        type: "address",
      },
    ],
    name: "executeIncreaseOrder",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_account",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_orderIndex",
        type: "uint256",
      },
      {
        internalType: "address payable",
        name: "_feeReceiver",
        type: "address",
      },
    ],
    name: "executeSwapOrder",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "feeReserves",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "gov",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "inLegacyMode",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "_path",
        type: "address[]",
      },
      {
        internalType: "address",
        name: "_indexToken",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_amountIn",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_minOut",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_sizeDelta",
        type: "uint256",
      },
      {
        internalType: "bool",
        name: "_isLong",
        type: "bool",
      },
      {
        internalType: "uint256",
        name: "_price",
        type: "uint256",
      },
    ],
    name: "increasePosition",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "increasePositionBufferBps",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "_path",
        type: "address[]",
      },
      {
        internalType: "address",
        name: "_indexToken",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_minOut",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_sizeDelta",
        type: "uint256",
      },
      {
        internalType: "bool",
        name: "_isLong",
        type: "bool",
      },
      {
        internalType: "uint256",
        name: "_price",
        type: "uint256",
      },
    ],
    name: "increasePositionETH",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "isLiquidator",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "isOrderKeeper",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "isPartner",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_account",
        type: "address",
      },
      {
        internalType: "address",
        name: "_collateralToken",
        type: "address",
      },
      {
        internalType: "address",
        name: "_indexToken",
        type: "address",
      },
      {
        internalType: "bool",
        name: "_isLong",
        type: "bool",
      },
      {
        internalType: "address",
        name: "_feeReceiver",
        type: "address",
      },
    ],
    name: "liquidatePosition",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "maxGlobalLongSizes",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "maxGlobalShortSizes",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "orderBook",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "referralStorage",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "router",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address payable",
        name: "_receiver",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "sendValue",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_admin",
        type: "address",
      },
    ],
    name: "setAdmin",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_depositFee",
        type: "uint256",
      },
    ],
    name: "setDepositFee",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_gov",
        type: "address",
      },
    ],
    name: "setGov",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bool",
        name: "_inLegacyMode",
        type: "bool",
      },
    ],
    name: "setInLegacyMode",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_increasePositionBufferBps",
        type: "uint256",
      },
    ],
    name: "setIncreasePositionBufferBps",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_account",
        type: "address",
      },
      {
        internalType: "bool",
        name: "_isActive",
        type: "bool",
      },
    ],
    name: "setLiquidator",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "_tokens",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "_longSizes",
        type: "uint256[]",
      },
      {
        internalType: "uint256[]",
        name: "_shortSizes",
        type: "uint256[]",
      },
    ],
    name: "setMaxGlobalSizes",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_account",
        type: "address",
      },
      {
        internalType: "bool",
        name: "_isActive",
        type: "bool",
      },
    ],
    name: "setOrderKeeper",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_account",
        type: "address",
      },
      {
        internalType: "bool",
        name: "_isActive",
        type: "bool",
      },
    ],
    name: "setPartner",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_referralStorage",
        type: "address",
      },
    ],
    name: "setReferralStorage",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bool",
        name: "_shouldValidateIncreaseOrder",
        type: "bool",
      },
    ],
    name: "setShouldValidateIncreaseOrder",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "shortsTracker",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "shouldValidateIncreaseOrder",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "vault",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "weth",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_token",
        type: "address",
      },
      {
        internalType: "address",
        name: "_receiver",
        type: "address",
      },
    ],
    name: "withdrawFees",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    stateMutability: "payable",
    type: "receive",
  },
] as const;

const _bytecode =
  "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";

type PositionManagerConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: PositionManagerConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class PositionManager__factory extends ContractFactory {
  constructor(...args: PositionManagerConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override getDeployTransaction(
    _vault: AddressLike,
    _router: AddressLike,
    _shortsTracker: AddressLike,
    _weth: AddressLike,
    _depositFee: BigNumberish,
    _orderBook: AddressLike,
    overrides?: NonPayableOverrides & { from?: string }
  ): Promise<ContractDeployTransaction> {
    return super.getDeployTransaction(
      _vault,
      _router,
      _shortsTracker,
      _weth,
      _depositFee,
      _orderBook,
      overrides || {}
    );
  }
  override deploy(
    _vault: AddressLike,
    _router: AddressLike,
    _shortsTracker: AddressLike,
    _weth: AddressLike,
    _depositFee: BigNumberish,
    _orderBook: AddressLike,
    overrides?: NonPayableOverrides & { from?: string }
  ) {
    return super.deploy(
      _vault,
      _router,
      _shortsTracker,
      _weth,
      _depositFee,
      _orderBook,
      overrides || {}
    ) as Promise<
      PositionManager & {
        deploymentTransaction(): ContractTransactionResponse;
      }
    >;
  }
  override connect(runner: ContractRunner | null): PositionManager__factory {
    return super.connect(runner) as PositionManager__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): PositionManagerInterface {
    return new Interface(_abi) as PositionManagerInterface;
  }
  static connect(
    address: string,
    runner?: ContractRunner | null
  ): PositionManager {
    return new Contract(address, _abi, runner) as unknown as PositionManager;
  }
}
